import { apiFetch } from '@/lib/api';

export interface InvestorTopicCount { name: string; count: number }
export interface InvestorsStats {
  total: number;
  active: number;
  inactive: number;
  tagged_topics: number;
  by_investor: InvestorTopicCount[];
}

export function getInvestorsStats(): Promise<InvestorsStats> {
  return apiFetch<InvestorsStats>('/investors-admin/stats');
}
